import { OKXUniversalConnectUI, THEME } from "@okxconnect/ui";
import { isWeb } from "./mode";

export const connectWallet = () => {
  return OKXUniversalConnectUI.init({
    dappMetaData: {
      icon: "https://static.okx.com/cdn/assets/imgs/247/58E63FEA47A2B7D7.png",
      name: "Capybara",
    },
    actionsConfiguration: {
      returnStrategy: isWeb  ? "back" : "tg://resolve",
      modals: "all",
    },
    language: "en_US",
    uiPreferences: {
      theme: THEME.LIGHT,
    },
  });
};
